export enum FeedbackTypeEnum {
    CURSO = "curso",
    MODULO = "modulo",
    LECCION = "leccion",
    TUTOR = "tutor",
}